export default [
  { index: 0, caseType: "Endodontics", caseTypeSlug: "endodontics" },
  { index: 1, caseType: "Orthodontics", caseTypeSlug: "orthodontics" },
  { index: 2, caseType: "Minimal intervention dentistry", caseTypeSlug: "minimal-intervention-dentistry" },
  { index: 3, caseType: "Prosthodontics", caseTypeSlug: "prosthodontics" },
  { index: 4, caseType: "Pediatric dentistry", caseTypeSlug: "pediatric-dentistry" },
  { index: 5, caseType: "Preventive dentistry", caseTypeSlug: "preventive-dentistry" },
  { index: 6, caseType: "Periodontics", caseTypeSlug: "periodontics" },
  { index: 7, caseType: "Oral and maxillofacial surgery", caseTypeSlug: "oral-and-maxillofacial-surgery" },
  { index: 8, caseType: "Dento-maxillofacial radiology", caseTypeSlug: "dento-maxillofacial-radiology", hidden: true },
  { index: 9, caseType: "Oral pathology", caseTypeSlug: "oral-pathology", hidden: true },
  { index: 10, caseType: "Oral medicine", caseTypeSlug: "oral-medicine" },
  { index: 11, caseType: "Dento-Facial Photography", caseTypeSlug: "dento-facial-photography" },
  { index: 12, caseType: "Microscopic Dentistry", caseTypeSlug: "microscopic-dentistry" },
  { index: 13, caseType: "Implant Dentistry", caseTypeSlug: "implant-dentistry" },
  { index: 14, caseType: "Facial Aesthetics", caseTypeSlug: "facial-aesthetics" },
  { index: 15, caseType: "Cosmetic and Restorative Dentistry", caseTypeSlug: "cosmetic-and-restorative-dentistry" },
];



// WEBPACK FOOTER //
// ./src/constants/caseTypes.js